// ADS
export const ADS_ANALYTICS_NAMESPACE = 'ads';
export const ADS_COHORTS_NAMESPACE = 'ads-cohorts';

// EMAIL
export const EMAIL_ANALYTICS_NAMESPACE = 'email';
export const EMAIL_COHORTS_NAMESPACE = 'email-cohorts';

// SEO
export const SEO_ANALYTICS_NAMESPACE = 'seo-analytics';

// OTT
export const OTT_ANALYTICS_NAMESPACE = 'ott-analytics';

// TRUE VIEW (UNIFIED ANALYTICS, SKAN/NON-SKAN)
export const TRUEVIEW_ANALYTICS_NAMESPACE = 'trueview-analytics';

// FRAUD
export const FRAUD_NAMESPACE = 'fraud';
export const FRAUD_CHART_CONTEXT = 'fraud-chart';
export const FRAUD_TABLE_CONTEXT = 'fraud-table';

// JOURNEYS ANALYTICS
export const JOURNEYS_ANALYTICS_NAMESPACE = 'journeys';
export const JOURNEYS_ANALYTICS_TIMESERIES_CONTEXT = 'journeys-time-series';
export const JOURNEYS_ANALYTICS_TABLE_CONTEXT = 'journeys-performance-table';
export const JOURNEYS_COHORTS_NAMESPACE = 'journeys-cohorts';

// LINK STATS
export const LINK_STATS_NAMESPACE = 'link-stats';

// LIVEVIEW
// NOTE: These are appended later with the tab name to create the namespaces
export const LEGACY_LIVEVIEW_NAMESPACE = 'LEGACY_LIVEVIEW';
export const LIVEVIEW_PBA_NAMESPACE = 'liveview';

// SOURCE ANALYTICS
export const SOURCE_ANALYTICS_NAMESPACE = 'source';

// SUMMARY
export const SUMMARY_NAMESPACE = 'main';
export const NEW_SUMMARY_NAMESPACE = 'summary';

// CUSTOM EXPORTS TEMPLATES
export const CUSTOM_EXPORTS_TEMPLATES_NAMESPACE = 'custom-exports-templates';

// CUSTOM EXPORTS
export const CUSTOM_EXPORTS_NAMESPACE = 'custom-exports';

// DISCOVERY ADS
export const DISCO_ADS_NAMESPACE = 'disco-ads';

// CONFIGURATION
export const DEEPVIEW_ACTIVITY_NAMESPACE = 'deepview-activity';

// SKADNETWORK
export const SK_ADNETWORK_NAMESPACE = 'skadnetwork';

// All reports that are shared by all apps / orgs are stored in DB with the
// following app id.
export const SHARED_REPORTS_APP_ID = '0';
